import { FieldValues, Path, UseFormReturn } from "react-hook-form";

export default function toggleRowSelect<T extends FieldValues>(methods: UseFormReturn<T>, fieldName: Path<T>, id: string) {
  let selectIds = methods.getValues(fieldName) as string[];

  if (selectIds.includes(id)) {
    selectIds = selectIds.filter((thisId) => thisId !== id);
  } else {
    selectIds = [...selectIds, id];
  }

  methods.setValue(fieldName, selectIds as any);
}
